import { SubscriptionPlanType } from "@shared/types";
import { preprocessPlansData } from "@shared/features/settings/subscription/utils";
import { sharedLib } from "@shared/services/shared.service";
import { useMemo } from "react";
import { skipToken } from "@reduxjs/toolkit/query";

export const useGetSubscriptionPlans = (
  subGroupId?: number,
  promoCode?: string | null,
  skip?: boolean
) => {
  const args = useMemo(() => {
    if (skip) return skipToken;
    return subGroupId || promoCode
      ? { sub_group_id: subGroupId, promo_code: promoCode }
      : undefined;
  }, [promoCode, subGroupId, skip]);

  return sharedLib.sharedApi.settings.useGetAllPlanDetailsQuery(args, {
    selectFromResult: ({ data: plans, isFetching, isLoading }) => {
      const filteredPlans =
        plans?.filter(
          (plan) => plan.subscription_plan_type in SubscriptionPlanType
        ) || [];
      return {
        plans: preprocessPlansData(filteredPlans),
        isFetching: isFetching,
        isLoading,
      };
    },
  });
};
